import { PropsWithChildren, useEffect, useRef, useState } from "react";

type Props = {
  duration?: number;
};

export const Slideshow: React.FC<PropsWithChildren<Props>> = ({ children, duration = 150 }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentWidth, setContentWidth] = useState<number | undefined>();

  const animation1 = contentWidth ? `slideshow1 ${duration}s linear infinite` : undefined;
  const animation2 = contentWidth ? `slideshow2 ${duration}s linear infinite` : undefined;
  const containerWidth = contentWidth ? `${contentWidth * 2}px` : undefined;

  useEffect(() => {
    if (!contentRef.current) return;
    const { width } = contentRef.current.getBoundingClientRect();
    setContentWidth(Math.round(width));
  }, []);

  return (
    <div className="relative h-10 min-w-full overflow-hidden bg-black select-none whitespace-nowrap">
      <div
        style={{
          position: "relative",
          minWidth: containerWidth,
        }}
      >
        <div
          ref={contentRef}
          className="flex flex-row justify-around"
          style={{
            position: "absolute",
            animation: animation1,
            width: "fit-content",
          }}
        >
          {children}
        </div>
        <div
          className="flex flex-row justify-around"
          style={{
            position: "absolute",
            animation: animation2,
            width: "fit-content",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
